import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;



const axiosConfig = {};
const axiosProps = {
  headers: {
      "Content-Type": "application/json",
  },
};

if (import.meta.env.DEV) {
  axiosProps.baseURL = BASE_URL;
}

const axiosInstance = axios.create(axiosProps);

axiosInstance.interceptors.request.use((config) => {
  if (config.url?.startsWith("/api/v1/um/login")) {
    return config;
  }
  if (axiosConfig.token) {
      config.headers.Authorization = `Bearer ${axiosConfig.token}`;
  } else if (config.url?.startsWith("/api/v1/um/me") && import.meta.env.DEV) {
      const token = localStorage.getItem("tenancy_access_token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
  }
  
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.url?.startsWith("/api/v1/um/login") && response.data.status === 'OK') {
      axiosConfig.token = response.data.value;
    } else if (response.config.url?.startsWith('/api/v1/um/me') && !response.config.url?.startsWith("/api/v1/um/me/cognito") && response.config.method === 'get' && response.data.status === 'OK') {
      axiosConfig.token = response.data.value.token;
    }
    return response?.data ? response.data : response;
  },
  (error) => {
    const { url } = error.config;
    if (error.response?.status === 401 && url.indexOf("/api/v1/um/logout") === -1) {
        if (axiosConfig.unauthorizedHandler) {
          return axiosConfig.unauthorizedHandler(error, url);
        }
    } else if (error.response?.status >= 500 && axiosConfig.serviceErrorHandler) {
        return axiosConfig.serviceErrorHandler(error);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;

export const initAxios = ({ unauthorizedHandler, serviceErrorHandler }) => {
  axiosConfig.unauthorizedHandler = unauthorizedHandler;
  axiosConfig.serviceErrorHandler = serviceErrorHandler;
};